import { formatAddedDate } from '../../../utils/formatters';
import { getServiceUrl } from '../../../utils/serviceUrls';

const AlbumImage = ({ image }) => (
  <div className="sm:row-span-2 row-span-3 relative -mb-80">
    <img
      className="w-full aspect-square bg-cover bg-top bg-no-repeat shadow-2xl"
      src={image}
      alt="Album cover"
    />
  </div>
);

const AlbumHeader = ({ name, albumNumber, artist, releaseDate, genres, preventOrphanWords, item }) => {
  const preferredService = localStorage.getItem('preferredMusicService') || 'spotify';
  const serviceUrl = item ? getServiceUrl(item.album, preferredService) : null;

  return (
    <>
      <div className="col-span-2 pangram-sans-bold md:text-4xl sm:text-3xl text-2xl md:leading-9.5 sm:leading-8 leading-7">
        {name ? preventOrphanWords(name) : ''}
      </div>
      <div className="col-start-2 col-span-2 flex flex-wrap sm:justify-between gap-x-4 gap-y-2">
        <div className="flex flex-wrap gap-4 items-center">
          {serviceUrl && (
            
            <a className="hover:scale-110 transition duration-100 ease-in-out opacity-30 hover:opacity-100"
              href={serviceUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="material-symbols-outlined sm:text-2xl text-xl">play_circle</span>
            </a>
          )}

         {/* add the 'language' icon / 1001 link here */}
          <a
            className="hover:scale-110 transition duration-100 ease-in-out opacity-30 hover:opacity-100"
            href={item.album.globalReviewsUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="material-symbols-outlined sm:text-2xl text-xl">language</span>
          </a>
          
        <span>#{albumNumber}</span>
        <span>{artist ? preventOrphanWords(artist) : ''}</span>
        <span>{releaseDate}</span>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        {genres?.map(genre => (
          <span key={genre} className="px-2 rounded-full bg-black/5">
            {genre}
          </span>
        ))}
      </div>
    </div >
    </>
  );
};

const AlbumDetails = ({ rating, generatedAt, review, preventOrphanWords }) => (
  <div className="grid gap-y-1 sm:gap-x-6 gap-x-4 sm:p-6 p-4 sm:pt-3 pt-2 bg-[#F2EEDF]
    md:grid-cols-[7.75rem,minmax(0,1fr),minmax(0,1fr)]
    sm:grid-cols-[7.3rem,minmax(0,1fr),minmax(0,1fr)]
    grid-cols-[6rem,minmax(0,1fr),minmax(0,1fr)]">
    <div className="col-start-2 content-center">
      <div className="flex flex-row items-center justify-start select-none">
        {[...Array(5)].map((_, index) => (
          <span
            key={index}
            className={`material-symbols-outlined sm:text-2xl text-xl sm:leading-6 leading-4 ${index < rating ? 'star-select' : 'star-stroke opacity-30'
              }`}
          >
            star
          </span>
        ))}
      </div>
    </div>
    <div className="max-sm:col-span-2 max-sm:col-start-2 max-sm:row-start-3 content-center sm:text-right">
      <span className="opacity-50">{formatAddedDate(generatedAt)}</span>
    </div>
    <div className="col-start-2 col-span-2">
      {review ? preventOrphanWords(review) : ''}
    </div>
  </div>
);

export const AlbumListView = ({ item, albumNumber, preventOrphanWords }) => (
  <div className="grid grid-rows-[auto,auto] rounded-2xl overflow-clip">
    <div className="grid gap-y-1 sm:gap-x-6 gap-x-4 sm:p-6 p-4 sm:pb-3 pb-2 bg-amber-50
      md:grid-cols-[7.75rem,minmax(0,1fr),minmax(0,1fr)]
      sm:grid-cols-[7.3rem,minmax(0,1fr),minmax(0,1fr)]
      grid-cols-[6rem,minmax(0,1fr),minmax(0,1fr)]">
      <AlbumImage image={item.album.images[1]?.url} />
      <AlbumHeader
        name={item.album.name}
        albumNumber={albumNumber}
        artist={item.album.artist}
        releaseDate={item.album.releaseDate}
        genres={item.album.genres}
        preventOrphanWords={preventOrphanWords}
        item={item}
      />
    </div>
    <AlbumDetails
      rating={item.rating}
      generatedAt={item.generatedAt}
      review={item.review}
      preventOrphanWords={preventOrphanWords}
    />
  </div>
);